import { m } from "@/paraglide/messages"
import type { EiSubscale } from "./types"

const EI_SUBSCALE_DESCRIPTIONS: Record<
	EiSubscale["slug"],
	{ strong: () => string; weak: () => string }
> = {
	reading_faces: {
		strong: m.eiSubscaleReadingFacesStrong,
		weak: m.eiSubscaleReadingFacesWeak,
	},
	overall_vibe: {
		strong: m.eiSubscaleOverallVibeStrong,
		weak: m.eiSubscaleOverallVibeWeak,
	},
	understanding_situations: {
		strong: m.eiSubscaleUnderstandingSituationsStrong,
		weak: m.eiSubscaleUnderstandingSituationsWeak,
	},
	inner_motor: {
		strong: m.eiSubscaleInnerMotorStrong,
		weak: m.eiSubscaleInnerMotorWeak,
	},
	empathy: {
		strong: m.eiSubscaleEmpathyStrong,
		weak: m.eiSubscaleEmpathyWeak,
	},
	mood_shifts: {
		strong: m.eiSubscaleMoodShiftsStrong,
		weak: m.eiSubscaleMoodShiftsWeak,
	},
	complex_emotions: {
		strong: m.eiSubscaleComplexEmotionsStrong,
		weak: m.eiSubscaleComplexEmotionsWeak,
	},
	situation_development: {
		strong: m.eiSubscaleSituationDevelopmentStrong,
		weak: m.eiSubscaleSituationDevelopmentWeak,
	},
	self_control: {
		strong: m.eiSubscaleSelfControlStrong,
		weak: m.eiSubscaleSelfControlWeak,
	},
	influence: {
		strong: m.eiSubscaleInfluenceStrong,
		weak: m.eiSubscaleInfluenceWeak,
	},
}

export function getEiSubscaleDescription(
	subscale: EiSubscale,
	kind: "superpowers" | "development",
): string {
	const description = EI_SUBSCALE_DESCRIPTIONS[subscale.slug]
	if (kind === "superpowers") return description.strong()
	return description.weak()
}
